import { useCallback } from 'react';

import { ArticleHeading1, ArticleHeading4, useDeviceType } from '@cian/ui-kit';

import { Switcher } from 'shared/components/Switcher';
import { useGuideAnalytics } from 'shared/hooks';
import { EDealType, EOfferType } from 'shared/types/features';
import type { ISwitcherFiltersProps } from 'shared/types/switcher';

export const SwitcherContainer: React.FC<ISwitcherFiltersProps> = ({
  offerType,
  onActiveOfferType,
  withDealType,
  dealType,
  onActiveDealType,
}) => {
  const device = useDeviceType();
  const isPhone = device === 'phone';
  const Title = isPhone ? ArticleHeading4 : ArticleHeading1;
  const textAlign = isPhone ? 'center' : 'left';
  const hasDealType = Boolean(withDealType && dealType && onActiveDealType);
  const { trackPageCategory } = useGuideAnalytics();

  const handleApartmentClick = useCallback((): void => {
    onActiveOfferType(EOfferType.Apartment);
    trackPageCategory(dealType, EOfferType.Apartment);
  }, [dealType, onActiveOfferType, trackPageCategory]);

  const handleSuburbanClick = useCallback((): void => {
    onActiveOfferType(EOfferType.Suburban);
    trackPageCategory(dealType, EOfferType.Suburban);
  }, [dealType, onActiveOfferType, trackPageCategory]);

  const handleOfferTypeSwitch = useCallback((): void => {
    const nextOfferType = offerType === EOfferType.Suburban ? EOfferType.Apartment : EOfferType.Suburban;

    onActiveOfferType(nextOfferType);
    trackPageCategory(dealType, nextOfferType);
  }, [dealType, offerType, onActiveOfferType, trackPageCategory]);

  const handleDealTypeChange = useCallback(
    (nextDealType: EDealType): void => {
      onActiveDealType?.(nextDealType);
      trackPageCategory(nextDealType, offerType);
    },
    [offerType, onActiveDealType, trackPageCategory],
  );

  return (
    <Switcher
      device={device}
      title={<Title textAlign={textAlign}>Я хочу знать про</Title>}
      isSuburbanSelected={offerType === EOfferType.Suburban}
      onApartmentClick={handleApartmentClick}
      onSuburbanClick={handleSuburbanClick}
      onOfferTypeSwitch={handleOfferTypeSwitch}
      withDealType={hasDealType}
      dealType={dealType}
      onActiveDealType={handleDealTypeChange}
    />
  );
};
